import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-create-or-upgrade-org',
  templateUrl: './create-or-upgrade-org.component.html',
  styleUrls: ['./create-or-upgrade-org.component.scss']
})
export class CreateOrUpgradeOrgComponent implements OnInit {

  isProcessing: boolean = false;
  orgData: any = {};
  operation: any = "";
  releaseVersionDropdnown: any = [];
  dropdownForRelaseversion: any = [];
  selectedReleaseVersion: any = null;

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  @ViewChild('confirmationPopup', { static: true }) confirmationPopup: TemplateRef<any>;
  visibleConfimartionPopup: MatDialogRef<TemplateRef<any>>;

  confimationPopupConfig = {
    width: '700px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  firstLevel: any = '';
  secondLevel: any = '';
  constructor(public dialog: MatDialog, private appService: AppService, public router: Router, private snackBar: MatSnackBar,
    public paginationService: PaginationService, private route: ActivatedRoute, public message: messageService) {
    this.route.params.subscribe(
      params => {
        this.operation = params['operation'];
        if (this.operation == "Create") {
          this.dataFrom = "Create";
        } else {
          this.dataFrom = null;
        }
        this.firstLevel = this.message.breadcrumbData.firstLevel;
        this.secondLevel = this.operation;
        this.orgData = {};
      })
  }

  dataFrom: any;
  ngOnInit(): void {

    this.isProcessing = true;
    this.appService.getReleaseversions().subscribe((data: any) => {
      this.isProcessing = false;
      this.releaseVersionDropdnown = data;
      for (let i = 0; i < this.releaseVersionDropdnown.length; i++) {
        this.dropdownForRelaseversion = this.dropdownForRelaseversion.concat({
          valueExp: this.releaseVersionDropdnown[i],
          displayExp: this.releaseVersionDropdnown[i]
        });
      }
    })
    this.dropDownForTimezone = JSON.parse(sessionStorage.getItem('dropDownForTimezone') || '{}');
    this.selectBoxeForTimezone();
  }

  timezoneDropdown: any = [];
  dropDownForTimezone: any = [];
  selectedTimezoneValue: any = null;
  selectBoxeForTimezone() {
    for (let i = 0; i < this.dropDownForTimezone.length; i++) {
      let timeZoneValues = this.dropDownForTimezone[i].region + ' | ' + this.dropDownForTimezone[i].timezone + ' | ' + this.dropDownForTimezone[i].clock;
      this.timezoneDropdown = this.timezoneDropdown.concat({
        valueExp: this.dropDownForTimezone[i].timezone,
        displayExp: timeZoneValues
      });
    }
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  onTypeChanged(data: any) {

  }


  timezonesearchTxt: any;
  onTimezoneSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.orgData.timezone = item.valueExp;
        } else {
          this.orgData.timezone = null;

        }
      }
    }
  }

  /*   onTimezoneSelect(item: any) {
      this.orgData.timezone = item.valueExp;
    } */
  onTimezoneRemoved(item: any) { }

  /*   onVersionSelect(item : any){
      this.orgData.releaseVersion = item.valueExp;
    }
   */

  releaseVersionsearchTxt: any;
  onVersionSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.orgData.releaseVersion = item.valueExp;
        } else {
          this.orgData.releaseVersion = null;

        }
      }
    }
  }

  /*   onVersionRemoved(item : any){
      this.orgData.releaseVersion = null;
    } */

  resultMsg: any = '';
  resultType: any = '';
  createOrgFunc() {
    if (this.dataFrom == "allChildOrgs") {
      this.resultMsg = "";
      this.resultType = "";
      this.isProcessing = true;
      this.appService.upgradeChildOrganization(this.orgData).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "E") {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        } else {
          this.resultMsg = Response.result;
          this.resultType = Response.resultType;
          this.visibleConfimartionPopup = this.dialog.open(this.confirmationPopup, this.confimationPopupConfig);
        }

      }, (error) => {
        this.isProcessing = false;
        throw error;
      });
    } else {
      this.isProcessing = true;
      this.orgData['mode'] = this.operation == "Create" ? "CREATE" : "UPGRADE";
      this.appService.createOrUpgradeOrganization(this.orgData).subscribe((Response: any) => {
        this.isProcessing = true;
        if (Response.resultType == 'S') {
        } else {
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });

        this.isProcessing = false;
      }, (error) => {
        this.isProcessing = false;
        throw error;
      });
    }

  }

  okForConfirmation() {
    this.visibleConfimartionPopup.close();
  }

}
